import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';
import { CASH_PDF_MESSAGES } from '../../../core/constants/General-constants';
import { toPng } from 'html-to-image';
import * as pdfMake from 'src/libs/pdfmake-0.2.10/build/pdfmake';
import { ASSETS_CONSTANTS } from 'src/app/core/constants/Assets-constants';
import { convertImageToBase64 } from '../../helps/helps';

@Component({
    selector: 'app-download-cash-instructions-button',
    templateUrl: './download-cash-instructions-button.component.html',
    styleUrls: ['./download-cash-instructions-button.component.scss'],
})
export class DownloadCashInstructionsButtonComponent implements OnInit {
    @Input() networkName: string;
    @Input() agreementNetworkCode: string;
    @Input() referenceCode: string;
    loading: boolean = false;

    constructor(private alertService: AlertService) {}

    ngOnInit(): void {}

    /**
     *
     * @description {generatePdfInstructions} This method generates a PDF document from a specific HTML container
     * by capturing its content as an image using html-to-image and incorporating it into a new jsPDF instance
     */
    generatePdfInstructions() {
        const container = document.getElementById('content');
        const emptyContainer = document.getElementById('emptyContainer');

        const originalDisplay = container.style.display;
        const originalHeight = container.style.height;
        const originalWidth = container.style.width;

        const originalEmptyDisplay = emptyContainer.style.display;
        const originalEmptyHeight = emptyContainer.style.height;

        container.style.height = '800px';
        container.style.width = '450px';
        container.style.display = 'block';

        emptyContainer.style.height = '1000px';
        emptyContainer.style.display = 'block';

        try {
            this.loading = true;
            toPng(container).then((dataUrl) => {
                setTimeout(async () => {
                    const imageOneBase64 = await convertImageToBase64(ASSETS_CONSTANTS.PAYVALIDA_CASH_PAYMENT_INSTRUCTIONS);
                    const imageTwoBase64 = await convertImageToBase64(ASSETS_CONSTANTS.ALERT_ICON);

                    const documentDefinition = {
                        content: [
                            {
                                table: {
                                    body: [
                                        [
                                            {
                                                image: dataUrl,
                                                width: 515,
                                                height: 1080,
                                                border: [false, false, false, false],
                                                alignment: 'center',
                                                margin: [3, 100, 0, 0],
                                            },
                                        ],
                                        [
                                            {
                                                image: imageOneBase64,
                                                width: 350,
                                                height: 75,
                                                border: [false, false, false, false],
                                                margin: [3, -1205, 0, 0],
                                            },
                                        ],
                                        [
                                            {
                                                image: imageTwoBase64,
                                                width: 45,
                                                height: 45,
                                                alignment: 'right',
                                                border: [false, false, false, false],
                                                margin: [0, 0, 20, 0],
                                                absolutePosition: { x: 0, y: 775 },
                                            },
                                        ],
                                    ],
                                },
                                layout: 'noBorders',
                            },
                        ],
                    };

                    pdfMake.createPdf(documentDefinition).download(CASH_PDF_MESSAGES.CASH_PDF_NAME_FILE);

                    container.style.display = originalDisplay;
                    container.style.height = originalHeight;
                    container.style.width = originalWidth;

                    emptyContainer.style.height = originalEmptyHeight;
                    emptyContainer.style.display = originalEmptyDisplay;

                    this.loading = false;
                }, 1000);
            });
        } catch (error) {
            this.loading = false;
            this.alertService.showAlert(CASH_PDF_MESSAGES.ERROR);
        }
    }
}
